export default __webpack_public_path__ + "static/media/wcut.deb2461c.PNG";